import { useEffect, useState } from "react";

const useTable = (rows: any[]) => {
  const [results, setResults] = useState<any[]>([]);
  const [filter, setFilter] = useState<number>(-1);
  const [itemsPerPage, setItemsPerPage] = useState<number>(5);

  useEffect(() => {
    setResults(rows);
  }, [rows]);

  const handleResult = (result: any[]) => {
    setResults(result);
  };

  const onSelectChange = (event: any) => {
    const filter = event.target.value;
    setFilter(filter);
  };

  return {
    results,
    handleResult,
    onSelectChange,
    filter,
    itemsPerPage,
    setItemsPerPage,
  };
};

export default useTable;
